import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import Img from '../../../../Img' // task #67: canonical image component
import HighlightedText from '../../../../Utils/HighlightedText'
import InfoIcon from '../../../../icons/Info'

function R295Pairing({ imageCs, titleHl, textA, textB, warningText }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.title}>
            <HighlightedText {...titleHl}
                             highlightExactMatch={true}
            />
          </div>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={textA} noSpace/>
          </div>
        </div>
        {
          imageCs && (
            <div className={styles.mainImage}>
              {/* task #67: descriptor via <Img> */}
              <Img
                image={imageCs.image}
                alt={imageCs.alt}
                objectFit="contain"
              />
            </div>
          )
        }
        <div className={styles.textWrapper}>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={textB} noSpace/>
          </div>
          {
            warningText && <div className={styles.warningText}>
              <div className={styles.warningIcon}><InfoIcon/></div>
              <SimpleBlockContent blocks={warningText} noSpace/>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default R295Pairing
